/**
 * 浏览器端 Sentry 初始化插件。
 * 用于采集前端报错、性能追踪和当前用户信息，方便线上问题定位。
 */
import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const {
    sentryDsn,
    sentryEnvironment,
    sentryTracesSampleRate,
    sentryReplaySessionSampleRate,
    sentryReplayOnErrorSampleRate,
  } = config.public;

  if (!sentryDsn) {
    return;
  }

  const integrations: any[] = [Sentry.browserTracingIntegration()];

  if (sentryReplaySessionSampleRate > 0 || sentryReplayOnErrorSampleRate > 0) {
    integrations.push(Sentry.replayIntegration());
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentryDsn,
    environment: sentryEnvironment,
    tracesSampleRate: sentryTracesSampleRate,
    replaysSessionSampleRate: sentryReplaySessionSampleRate,
    replaysOnErrorSampleRate: sentryReplayOnErrorSampleRate,
    integrations,
  });

  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    Sentry.captureException(error, {
      tags: {
        source: "vue.error_handler",
        vue_info: info,
      },
      extra: {
        componentName: instance?.$options?.name,
      },
    });
  };

  nuxtApp.hook("app:error", (error) => {
    Sentry.captureException(error, {
      tags: {
        source: "nuxt.app_error",
      },
    });
  });
});
